import { deepMap } from "nanostores";
import type { CartWithPrismicData } from "@wbly/data-storefront";
import type { Store } from "../../../../types/stores";
import { cartDetails } from "./details.store";

type DiscountStore = Store & {
  error: {
    code:
      | "CART_DISCOUNT_NOT_FOUND"
      | "CART_DISCOUNT_APPLY_FAIL"
      | "CART_DISCOUNT_DELETE_FAIL";
  };
};

export const discount = deepMap<DiscountStore>({
  data: null,
  status: "idle",
  error: null,
});

export async function applyDiscount(code: string) {
  discount.setKey("status", "loading");
  discount.setKey("error", null);

  try {
    const applyDiscountResponse = await fetch("cart/data/discount.json", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ code }),
    });

    if (applyDiscountResponse.status === 200) {
      const cartDetailsData =
        (await applyDiscountResponse.json()) as CartWithPrismicData;
      cartDetails.setKey("data", cartDetailsData);

      discount.setKey("status", "success");
    } else if (applyDiscountResponse.status === 404) {
      // Specific error code for `404`, which is expected for invalid codes
      discount.setKey("status", "error");
      discount.setKey("error", {
        code: "CART_DISCOUNT_NOT_FOUND",
        message: "Promo code not found",
      });
    } else {
      throw Error(
        `Failed to apply discount with status ${applyDiscountResponse.status}`
      );
    }
  } catch (error) {
    console.error(error);
    discount.setKey("status", "error");
    discount.setKey("error", {
      code: "CART_DISCOUNT_APPLY_FAIL",
      message: error instanceof Error ? error.message : null,
    });
  }
}

export async function deleteDiscount() {
  discount.setKey("status", "loading");
  discount.setKey("error", null);

  try {
    const deleteDiscountResponse = await fetch("cart/data/discount.json", {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    });

    if (deleteDiscountResponse.status === 200) {
      const cartDetailsData =
        (await deleteDiscountResponse.json()) as CartWithPrismicData;
      cartDetails.setKey("data", cartDetailsData);

      // Reset to `idle` state when discount code removed
      discount.setKey("status", "idle");
    } else {
      throw Error(
        `Failed to delete discount with status ${deleteDiscountResponse.status}`
      );
    }
  } catch (error) {
    console.error(error);
    discount.setKey("status", "error");
    discount.setKey("error", {
      code: "CART_DISCOUNT_DELETE_FAIL",
      message: error instanceof Error ? error.message : null,
    });
  }
}
